import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//所有的组件要写详细的用途注释
export default new Router({
    routes: [ 
        //详情页
        {
            path: '/theme', component: require('../components/theme/theme.vue')
        },
        //运维页
        {
            path: '/unit',component: require('../components/operations/operations.vue'),
            children:[
                //单位
                {path: '/unit', component: require('../components/operations/unit/unit.vue')},
                //用户
                {path: '/user', component: require('../components/operations/user/user.vue')},
                /* //角色
                {path: '/role', component: require('../components/operations/role/role.vue')}, */
            ]
        },
        //一个空的路由里面灭有内容
        {
            path: '/noneroute', component: require('../components/route.vue')
        },
        //默认加载的路由
        {
            path:'*',redirect:'/theme'
        }
        
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js